import logo1 from "../../assets/img/historicEvents/LogoOnlysPPV/CapC.png";

export const capitalCarnageDetail = {
  "capital-carnage": {
    id: "capital-carnage",
    title: "Capital Carnage",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "capital-carnage",
        items: [
          {
            id: "capital-carnage-1",
            title: "Capital Carnage",
            description: "London, England 1998",
            imgUrl: logo1,
          },
        ],
      },
    ],
  },
};
